<footer class="page-footer font-small blue pt-4">
<div class="container-fluid text-center text-md-left">
    <div class="row">
        <div class="col-lg-4 col-sm-4">
          <h5 class="text-uppercase">About</h5>
          <p>hello to you we will help you to find everything you need witn private prices,hello to you we will help you to find everything you need witn private prices. </p>
          
            
          <div class="content">
              <i class="fab fa-facebook-f"></i>
              <i class="fab fa-twitter"></i>
              <i class="fab fa-instagram"></i>
              <i class="fab fa-invision"></i>
              <i class="fab fa-behance"></i>
          </div>

        </div>
        <!-- <hr class="clearfix w-100 d-md-none pb-3"> -->
        <div class="col-lg-4 col-sm-4 one">
         <h5 class="text-uppercase">Meta</h5>
         <ul class="list-unstyled">
            <li>
              <a routerLink="auth/login">Login</a>
            </li>
            <li>
                <a routerLink="auth/signup">Signup</a>
              </li>
            <li>
              <a routerLink="user/cart">View Cart</a>
            </li>
              
          </ul>
        </div>
        <div class="col-lg-4 col-sm-4">
            <h5 class="text-uppercase">Newsletter</h5>
            <p>hello to you we will help you to find everything </p>
            <input type="email" placeholder="Enter your Email">
            <br>
            <button type="button" class="btn btn-success">Subscribe</button>

        </div>
    </div>
        
</div>
 


<div class="footer-copyright text-center py-3">Copyright 2021 RenoshopBee all right reserved - Design by samah Refaat
</div>

</footer>